import * as React from 'react';
import { Link, LinkProps } from 'react-router-dom';

const RouterLink = React.forwardRef<HTMLAnchorElement, LinkProps>(function RouterLink(props, ref) {
    return <Link innerRef={ref} {...props} />;
});

export default RouterLink;
